// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2yfzm","signatureButtonsRight":"ModalSign_signatureButtonsRight__EYnkx"};